import { styled } from '@mui/system'
import { truncate } from '@assets/styles/mixins/index.styles'
import { TTheme } from '@/core/theme'

export const DomainUrlWrapper = styled('div')`
    min-width: 0;
    overflow: hidden;
`

export const DomainContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    max-width: 220px;

    .domain-url {
        ${truncate};
    }

    .close-icon {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;

        &:hover {
            svg {
                transition: all 0.2s linear;
                fill: ${({ theme }) => theme.colors.greys[200]};
            }
        }
    }
`
